// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VXbm","toggle":"styles_toggle__2IuBS","preview":"styles_preview__3q61n"};